/**
 * Capitalize the first letter of a string.
 */
export function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
/**
 * Format a camelCase or PascalCase string into a human-readable label.
 *
 * @param str - The string to format (e.g., 'materialDeveloper')
 * @returns Formatted label (e.g., 'Material Developer')
 */
export function formatLabel(str) {
    return str
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
        .replace(/^./, (char) => char.toUpperCase());
}
/**
 * Convert a string to a URL-safe slug.
 *
 * @param str - The string to slugify (e.g., 'Jewels Of The Rainforest')
 * @returns Slugified string (e.g., 'jewels-of-the-rainforest')
 */
export function slugify(str) {
    return str
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_]+/g, '-')
        .replace(/-+/g, '-');
}
